<template>
  <div class="package-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูปปก</label>
        <img class="image" :src="modalImageUrl" />
        <sc-button v-if="!disabled && !isDisabledByLanguageNotTH" class="thumbnail-button"
          @click="handleClickChooseImageButton">เลือกรูปปก​</sc-button>
        <br />
        <label class="label">รูป Thumbnail</label>
        <img class="thumbnail" :src="modalThumbnailUrl" />
        <sc-button v-if="!disabled && !isDisabledByLanguageNotTH" class="thumbnail-button"
          @click="handleClickChooseThumbnailButton">เลือกรูป Thumbnail​</sc-button>
      </div>
      <div class="col info-editor">
        <label class="label" v-if="id">ชื่อ (ID: {{ id }})</label>
        <label class="label" v-else>ชื่อ</label>
        <el-input class="input" :value="name" @input="handleChangeInput('name', $event)" :disabled="disabled"></el-input>
        <label class="label">Keyword ค้นหาหน้า app (keywordคั่นด้วย , )</label>
        <el-input class="input" :value="keywords" @input="handleChangeInput('keywords', $event)" :disabled="disabledAndCheckLanguageNotTH"></el-input>
        <div>
          <el-checkbox v-model="value.isNotSendReceipt" :disabled="isDisabledByLanguageNotTH">ไม่ส่งใบเสร็จ</el-checkbox>
        </div>
        <label class="label">ชื่อที่แสดงในใบเสร็จ/ใบกำกับภาษี</label>
        <el-input class="input" :value="receiptName" @input="handleChangeInput('receiptName', $event)"
          :disabled="disabledAndCheckLanguageNotTH || value.isNotSendReceipt"></el-input>
        <div>
          <label class="label">อายุการใช้งานของแพ็กเกจ</label>
          <el-checkbox v-model="isTemporaryPackage" :disabled="isDisabledByLanguageNotTH">
            แพ็กเกจนี้สามารถสมัครหรือต่ออายุได้จนถึงวันที่
            <date-picker class="input" type="date" v-model="expiredDate" :disabled="!isTemporaryPackage"></date-picker>
          </el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="value.isExpireAfterAppointment">นับจากนัดหมายครั้งที่1</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="hasDiscountPromotion"
            :disabled="isDisabledByLanguageNotTH">จัดโปรโมชั่นลดราคา</el-checkbox>
        </div>
        <template v-if="!hasDiscountPromotion">
          <label class="label">ราคา (บาท)</label>
          <el-input class="input" :disabled="disabledAndCheckLanguageNotTH" :value="price"
            @input="handleChangeInput('price', $event)" type="number" min="0"></el-input>
        </template>
        <template v-else>
          <label class="label">ราคาเต็ม (บาท)</label>
          <el-input class="input" :disabled="disabledAndCheckLanguageNotTH" v-model="originalPrice"
            type="number"></el-input>
          <label class="label">ลดแล้วเหลือ (บาท) -
            <small>ระบบจะทำการ<strong>ตัดเงิน</strong>ลูกค้าจากยอดนี้</small></label>
          <p class="help-inline"></p>
          <el-input class="input" :disabled="disabledAndCheckLanguageNotTH" :value="price"
            @input="handleChangeInput('price', $event)" type="number" min="0"></el-input>
        </template>
        <label class="label">รอบตัดบิล (จำนวนเดือน)</label>
        <el-input class="input" :disabled="disabledAndCheckLanguageNotTH" :value="billingCycle"
          :readonly="value.isReadonlyPackage" @input="handleChangeInput('billingCycle', $event)" type="number"
          min="0"></el-input>
        <div v-if="!billingCycle">
          <label class="label">กำหนดอายุการใช้งานบนแอป (จำนวนเดือน)</label>
          <el-input
            class="input"
            :disabled="disabledAndCheckLanguageNotTH"
            :readonly="value.isReadonlyPackage"
            @input="handleChangeInput('expireDuration', $event)"
            :value="expireDuration"
            type="number"
            min="1"
          ></el-input>
        </div>
        <!-- 
        * [RJAPP-6698] Enable only if RueJai Payment Gateway already support SC Able merchant

        <div v-if="!billingCycle" class="checkbox-container">
          <label class="label">รายการผ่อนชำระ</label>
          <el-checkbox-group v-model="value.paymentCampaignIds">
            <el-checkbox
              v-for="campaign in paymentCampaignsWithSelection"
              :key="campaign.id"
              :label="campaign.id"
              v-model="campaign.isChecked"
            >
              <img :src="campaign.bank_logo_url" width="20" height="20" />
              <span style="margin-left: 5px"></span>
              <span style="font-weight: bold">{{ campaign.bank_name }}</span>
              {{ campaign.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        -->
        <div>
          <label class="label">แจ้งเตือนล่วงหน้าก่อนหมดอายุ</label>
        </div>
        <div>
          <el-checkbox v-model="value.hasAdvanceNotice" :disabled="isDisabledByLanguageNotTH">
            ต้องการแจ้งเตือน ก่อนหมดอายุ
            <el-input class="input-amount" type="number" min="1" :value="value.advanceNoticeDuration"
              @input="handleChangeInput('advanceNoticeDuration', $event)" :disabled="!value.hasAdvanceNotice"></el-input>
            วัน
          </el-checkbox>
        </div>
        <div v-show="value.hasAdvanceNotice" class="mb-3">
          <label class="label">ข้อความแจ้งเตือน</label>
          <el-input class="input" v-model="value.advanceNoticeMessage" @input="handleChangeInput('advanceNoticeMessage', $event)"></el-input>
        </div>
        <label class="label">เหมาะสำหรับ</label>
        <el-input class="input" :disabled="disabled" v-model="target"></el-input>
        <div>
          <label class="label">จำกัดสิทธิ์การซื้อ</label>
          <el-select class="input" v-model="purchasingLimit" placeholder="ไม่จำกัดสิทธิ์"
            :disabled="isDisabledByLanguageNotTH" clearable>
            <el-option v-for="option in purchasingLimitOptions" :key="option.value" :value="option.value"
              :label="option.label">{{ option.label }}</el-option>
          </el-select>
        </div>
        <div>
          <label class="label">Package Collection</label>
        </div>
        <div v-show="hasSuperPack">
          <pre>เป็น Sub Package ของ</pre>
          <el-button round size="mini" v-for="(superpack, index) in value.superpackages" :key="index"
            @click="handleClickSubPack(superpack)" :disabled="isDisabledByLanguageNotTH">
            {{ superpack }}
          </el-button>
        </div>
        <div v-show="!hasSuperPack">
          <el-checkbox v-model="hasPackageCollection" :disabled="isDisabledByLanguageNotTH">เป็น Parent
            Package</el-checkbox>
          <div v-show="hasPackageCollection">
            <label class="label">Package ID</label>
            <el-input class="input" v-model="value.packageCollection"
              @input="handleChangeInput('packageCollection', $event)" :disabled="isDisabledByLanguageNotTH"></el-input>
            <el-button round size="mini" v-for="(subpack, index) in value.subpackages" :key="index"
              @click="handleClickSubPack(subpack)" :disabled="isDisabledByLanguageNotTH">
              {{ subpack }}
            </el-button>
          </div>
        </div>
        <label class="label">อื่น ๆ</label>
        <div>
          <el-checkbox v-model="value.isSecret" :disabled="isDisabledByLanguageNotTH">เป็น Package ลับ</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="hasRegistrationForm" :disabled="isDisabledByLanguageNotTH">มี Registration
            Form</el-checkbox>
          <template v-if="hasRegistrationForm">
            <label class="label mb-2">ข้อมูลเพิ่มเติมสำหรับ Registration Form</label>
            <package-extra-editor :disabled="isDisabledByLanguageNotTH" v-model="registrationForm"></package-extra-editor>
          </template>
        </div>
        <div>
          <el-checkbox v-model="hasNoteLabel" :disabled="isDisabledByLanguageNotTH">มีหัวข้อหมายเหตุ</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="hasPurchaseSuccessTitle"
            :disabled="isDisabledByLanguageNotTH">มีหัวข้อการสั่งซื้อสำเร็จ</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="hasPurchaseSuccessMessage"
            :disabled="isDisabledByLanguageNotTH">มีข้อความหลังการสั่งซื้อสำเร็จ</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="value.isIgnoreCountCoupon"
            :disabled="isDisabledByEditPackage">ไม่นับการซื้อครั้งแรก</el-checkbox>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <label class="label">จำนวนที่ซื้อได้สูงสุด</label>
            <el-input class="input-amount" type="number" min="1" :value="value.maximumQuantity"
              @input="handleChangeInput('maximumQuantity', $event)" :disabled="isDisabledByLanguageNotTH"></el-input>
          </div>
          <div class="col-4">
            <label class="label">จำนวนที่ซื้อได้ต่ำสุด</label>
            <el-input class="input-amount" type="number" min="1" :value="value.minimumQuantity"
              @input="handleChangeInput('minimumQuantity', $event)" :disabled="isDisabledByLanguageNotTH"></el-input>
          </div>
        </div>
        <!-- TODO: remove ENV check when ready to production -->
        <div v-show="hasNoteLabel" class="mb-3">
          <label class="label">หัวข้อหมายเหตุ</label>
          <el-input class="input" v-model="value.noteLabel" @input="handleChangeInput('noteLabel', $event)"></el-input>
        </div>
        <div class="mb-3">
          <label class="label">โครงการที่รองรับ</label>
          <project-selector :disabled="disabledAndCheckLanguageNotTH" :value="projects" @allProject="allProject"
            @input="handleChangeInput('projects', $event)"></project-selector>
        </div>
        <div class="mb-3">
          <label class="label">บ้านที่รองรับ (Per Unit)</label>
          <el-autocomplete class="home-search-input" v-model="searchHomeText" :fetch-suggestions="projectQuerySearch"
            placeholder="ค้นหาโครงการ / บ้านเลขที่ / รหัสโครงการ" :trigger-on-focus="false" @select="handleSelectHome"
            :disabled="isDisabledByLanguageNotTH">
            <template slot-scope="{ item }">
              <div class="user">
                <div class="home">{{ item.address_no }}</div>
                <div class="home">{{ item.project.project_name }} ({{ item.project.project_code }})</div>
              </div>
            </template>
          </el-autocomplete>
          <div class="home-box" v-if="homes && homes.length > 0">
            <p class="label count">บ้านที่รองรับจำนวน {{ homes.length }} หลัง</p>
            <div v-for="(home, index) in homes" :key="index" class="user-list-item">
              <div class="user">
                <div class="home">{{ home.address_no }}</div>
                <div class="home">{{ home.project.project_name }} ({{ home.project_code }})</div>
              </div>
              <button class="btn-delete" @click="handleClickDeleteHome(home.home_id)">
                <img src="/static/icons/trash.svg" :alt="$t('label.delete')" />
              </button>
            </div>
          </div>
        </div>
        <label class="label">รายละเอียด</label>
        <div>
          <!--el-input class="input" :value="detail" :disabled="disabled" @input="handleChangeInput('detail', $event)"
            type="textarea" rows="3"></el-input-->
          <div ref="editor" class="editor" :disabled="disabled"></div>
        </div>
        <label class="label">เงื่อนไขการใช้บริการ</label>
        <div>
          <!--el-input class="input" :value="termsAndConditions" :disabled="disabled"
            @input="handleChangeInput('termsAndConditions', $event)" type="textarea" rows="7"></el-input-->
          <div ref="term_editor" class="editor" :disabled="disabled"></div>
        </div>
        <div v-show="hasPurchaseSuccessTitle">
          <label class="label">หัวข้อการสั่งซื้อสำเร็จ</label>
          <el-input class="input" v-model="purchaseSuccessTitle"></el-input>
        </div>
        <div v-show="hasPurchaseSuccessMessage">
          <label class="label">ข้อความหลังการสั่งซื้อสำเร็จ</label>
          <el-input class="input" v-model="purchaseSuccessMessage" type="textarea" rows="7"></el-input>
        </div>
        <hr class="line-pricings" />
        <label class="label">Pricings</label>
        <div>
          <label class="label">ผู้จัดหาบริการ</label>
          <el-select class="input sellerTradeParty" v-model="sellerTradePartyId" placeholder="เลือกผู้จัดหาบริการ"
            :disabled="disabledAndCheckLanguageNotTH">
            <el-option v-for="option in sellerTradePartyOptions" :key="option.value" :value="option.value"
              :label="option.label">{{ option.label }}</el-option>
          </el-select>
        </div>

        <service-selector class="input" :value="services" :disabled="disabled || value.isReadonlyPackage"
          @input="handleChangeInput('services', $event)"></service-selector>
        <div v-if="packageOptions">
          <label class="label">การตั้งค่าสำหรับทุกตัวเลือกสินค้า</label>
          <package-option-price-editor class="input" :value="packageOptions" :disabled="disabledAndCheckLanguageNotTH"
            @totalPrice="handleChangeTotalPrice"></package-option-price-editor>
        </div>
        <label class="label">MNC</label>
        <div class="row">
          <div class="col-sm">
            <div class="label indent-checkbox"></div>
            <input type="radio" value="no" class="larger-checkbox" name="coinAmountStatus" v-model="coinAmountStatus" />
            <span class="indent-checkbox-title">ไม่ใช้ MNC เป็นส่วนลด</span>
          </div>
          <div class="col-sm">
            <div class="label indent-checkbox"></div>
            <input type="radio" value="percent" class="larger-checkbox" name="coinAmountStatus"
              v-model="coinAmountStatus" />
            <span class="indent-checkbox-title">ใช้ MNC ลดเป็นเปอร์เซ็นต์</span>
            <el-input class="input" :disabled="disabledCoinAmountPercent" :value="coinAmountPercent"
              @input="handleChangeInput('coinAmountPercent', $event)" type="number" min="0" max="100"></el-input>
          </div>
          <div class="col-sm">
            <div class="label indent-checkbox"></div>
            <input type="radio" value="fix" class="larger-checkbox" name="coinAmountStatus" v-model="coinAmountStatus" />
            <span class="indent-checkbox-title">ใช้ MNC ลดเป็นบาท</span>
            <el-input class="input" :disabled="disabledCoinAmountFix" v-model.number="coinAmountFix" type="number"
              min="0"></el-input>
          </div>
        </div>
      </div>
    </div>
    <image-picker-modal v-bind="chooseThumbnailDialog" @cancel="handleCancelChooseThumbnailDialog"
      @confirm="handleConfirmChooseThumbnailDialog"></image-picker-modal>
    <album-and-swipe-picker v-bind="selectImageAlbumDialog" @cancel="handleCancelSelectAlbumDialog"
      @confirm="handleConfirmSelectAlbumDialog($event)"></album-and-swipe-picker>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { Input, Select, Option, Checkbox, Button, Autocomplete } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ProjectSelector from "@/lib/components/ProjectSelector";
import ServiceSelector from "@/lib/components/ServiceSelector/ServiceSelector";
import PackageExtraEditor from "./PackageExtraEditor";
import PackagePricingEditor from "./PackagePricingEditor";
import DatePicker from "@/lib/components/DatePicker";
import { isNil } from "ramda";
import { DateTime } from "luxon";
import PackageOptionPriceEditor from "./PackageOptionPriceEditor";
import AlbumAndSwipePicker from "@/lib/components/AlbumAndSwipePicker";
import {
  convertStangToBathAndRoundTwoDecimal,
  convertBathToStangAndRoundTwoDecimal
} from "@/lib/formatter";

export default {
  props: [
    "value",
    "imageUrl",
    "thumbnailUrl",
    "disabled",
    "targets",
    "sellerTradeParties",
    "paymentCampaigns",
    "isDisabledByLanguageNotTH",
    "isDisabledByEditPackage"
  ],
  components: {
    ScButton,
    ImagePickerModal,
    ServiceSelector,
    ProjectSelector,
    PackageExtraEditor,
    PackagePricingEditor,
    DatePicker,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    "el-button": Button,
    PackageOptionPriceEditor,
    AlbumAndSwipePicker,
    ElAutocomplete: Autocomplete
  },
  data() {
    const cache = {
      originalPrice: this.value.originalPrice,
      price: this.value.price,
      expiredAt: this.value.expiredAt
    };

    const extraTypeOptions = [
      { value: "1", label: "ข้อความ" },
      { value: "2", label: "ข้อความยาว" },
      { value: "3", label: "รูปบัตรประชาชน" }
    ];

    const extraPrefillOptions = [
      { value: "1", label: "ชื่อ" },
      { value: "2", label: "นามสกุล" },
      { value: "3", label: "เบอร์โทรศัพท์" },
      { value: "3", label: "บัตรประชาชน / Passport" }
    ];

    const purchasingLimitOptions = [
      { value: "PER_HOME", label: "บ้านละครั้ง" },
      { value: "PER_USER", label: "คนละครั้ง" }
    ];

    return {
      isShowModal: false,
      isShowThumbnailModal: false,
      extraTypeOptions,
      extraPrefillOptions,
      purchasingLimitOptions,
      cache,
      isShowSelectImageAlbum: false,
      searchHomeText: '',
      detailLength: 0,
      termLength: 0,
      currentDetailLanguage: null,
      currentTermLanguage: null,
      allProjects: [],
      selectedCampaigns: [],
    };
  },
  computed: {
    isProductionENV() {
      return process.env.DEPLOY_ENV == "production";
    },
    target: {
      get() {
        return this.value.target;
      },
      set(target) {
        this.$emit("input", { ...this.value, target });
      },
    },
    paymentCampaignsWithSelection() {
      const campaignsWithSelection = this.paymentCampaigns || [];

      return campaignsWithSelection.map((campaign) => ({
        ...campaign,
        isChecked: this.value.paymentCampaignIds.includes(campaign.id),
      }));
    },
    hasDiscountPromotion: {
      get() {
        return typeof this.value.originalPrice === "number";
      },
      set(hasDiscountPromotion) {
        const originalPrice = hasDiscountPromotion
          ? this.value.originalPrice || this.value.price
          : undefined;

        this.$emit("input", {
          ...this.value,
          originalPrice: originalPrice,
          price: !hasDiscountPromotion
            ? this.value.originalPrice
            : this.value.price
        });
      }
    },
    hasPackageCollection: {
      get() {
        return !isNil(this.value.packageCollection);
      },
      set(hasPackageCollection) {
        const packageCollection = hasPackageCollection ? 0 : null;

        this.$emit("input", {
          ...this.value,
          packageCollection: packageCollection,
        });
      },
    },
    hasSuperPack: {
      get() {
        if (
          this.value.superpackages !== undefined &&
          this.value.superpackages !== null &&
          this.value.superpackages.length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    hasNoteLabel: {
      get() {
        return !isNil(this.value.noteLabel);
      },
      set(hasNoteLabel) {
        const noteLabel = hasNoteLabel ? "" : null;

        this.$emit("input", {
          ...this.value,
          noteLabel: noteLabel
        });
      }
    },
    hasAdvanceNotice: {
      get() {
        return !isNil(this.value.advanceNoticeMessage);
      },
      set(hasAdvanceNotice) {
        const advanceNoticeMessage = hasAdvanceNotice ? "" : null;

        this.$emit("input", {
          ...this.value,
          advanceNoticeMessage: advanceNoticeMessage
        });
      }
    },
    hasPurchaseSuccessTitle: {
      get() {
        return !isNil(this.value.purchaseSuccessTitle);
      },
      set(hasPurchaseSuccessTitle) {
        const purchaseSuccessTitle = hasPurchaseSuccessTitle ? "" : null;

        this.$emit("input", {
          ...this.value,
          purchaseSuccessTitle: purchaseSuccessTitle,
        });
      }
    },
    hasPurchaseSuccessMessage: {
      get() {
        return !isNil(this.value.purchaseSuccessMessage);
      },
      set(hasPurchaseSuccessMessage) {
        const purchaseSuccessMessage = hasPurchaseSuccessMessage ? "" : null;

        this.$emit("input", {
          ...this.value,
          purchaseSuccessMessage: purchaseSuccessMessage,
        });
      }
    },
    originalPrice: {
      get() {
        return this.value.originalPrice;
      },
      set(value) {
        return this.$emit("input", { ...this.value, originalPrice: +value });
      }
    },
    isTemporaryPackage: {
      get() {
        return !isNil(this.value.expiredAt);
      },
      set(isTemporaryPackage) {
        const expiredAt = isTemporaryPackage
          ? this.cache.expiredAt || DateTime.utc().setZone("utc+7").endOf("day")
          : null;

        this.$emit("input", {
          ...this.value,
          expiredAt: expiredAt
        });
      }
    },
    expiredDate: {
      get() {
        if (isNil(this.value.expiredAt)) return null;

        return this.value.expiredAt.setZone("utc+7").startOf("day");
      },
      set(expiredDate) {
        this.$emit("input", {
          ...this.value,
          expiredAt: expiredDate.setZone("utc+7").endOf("day")
        });
      }
    },
    purchaseSuccessTitle: {
      get() {
        return this.value.purchaseSuccessTitle;
      },
      set(purchaseSuccessTitle) {
        this.$emit("input", { ...this.value, purchaseSuccessTitle });
      }
    },
    purchaseSuccessMessage: {
      get() {
        return this.value.purchaseSuccessMessage || "";
      },
      set(purchaseSuccessMessage) {
        this.$emit("input", { ...this.value, purchaseSuccessMessage });
      }
    },
    optionForm: {
      get() {
        return this.value.optionForm;
      },
      set(optionForm) {
        return this.$emit("input", { ...this.value, optionForm });
      }
    },
    pricings: {
      get() {
        return this.value.pricings;
      },
      set(pricings) {
        return this.$emit("input", { ...this.value, pricings });
      }
    },
    hasRegistrationForm: {
      get() {
        return !isNil(this.value.registrationForm)
      },
      set(hasRegistrationForm) {
        this.$emit("input", {
          ...this.value,
          hasRegistrationForm,
          registrationForm: hasRegistrationForm
            ? {
              title: "",
              sections: []
            }
            : null
        });
      }
    },
    registrationForm: {
      get() {
        return this.value.registrationForm;
      },
      set(registrationForm) {
        return this.$emit("input", { ...this.value, registrationForm });
      }
    },
    purchasingLimit: {
      get() {
        return this.value.purchasingLimit;
      },
      set(purchasingLimit) {
        if (purchasingLimit === "") {
          return this.$emit("input", { ...this.value, purchasingLimit: null });
        }

        return this.$emit("input", { ...this.value, purchasingLimit });
      }
    },
    sellerTradePartyId: {
      get() {
        return this.value.sellerTradePartyId;
      },
      set(sellerTradePartyId) {
        return this.$emit("input", { ...this.value, sellerTradePartyId });
      }
    },
    id() {
      return this.value.id;
    },
    name() {
      return this.value.name;
    },
    keywords() {
      return this.value.keywords;
    },
    receiptName() {
      return this.value.receiptName;
    },
    detail() {
      return this.value.detail;
    },
    price() {
      return this.value.price;
    },
    billingCycle() {
      return this.value.billingCycle;
    },
    isOneTimePurchase() {
      return this.billingCycle === 0;
    },
    termsAndConditions() {
      return this.value.termsAndConditions;
    },
    services() {
      return this.value.services;
    },
    projects() {
      return this.value.projects;
    },
    homes() {
      return this.value.homes;
    },
    noteLabel() {
      return this.value.noteLabel;
    },
    advanceNoticeMessage() {
      return this.value.advanceNoticeMessage;
    },
    advanceNoticeDuration() {
      return this.value.advanceNoticeDuration;
    },
    modalThumbnailUrl() {
      if (!this.chooseThumbnailDialog.thumbnailUrl) {
        return "https://placehold.co/200x200";
      }

      return this.chooseThumbnailDialog.thumbnailUrl;
    },
    modalImageUrl() {
      if (!this.chooseImageDialog.thumbnailUrl) {
        return "https://placehold.co/1200x800";
      }

      return this.chooseImageDialog.thumbnailUrl;
    },
    targetId() {
      if (!this.value.target) {
        return null;
      }

      return this.value.target.id;
    },
    targetOptions() {
      return this.targets;
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name,
      }));

      return sellerTradePartyOptions;
    },
    chooseImageDialog() {
      return {
        thumbnailUrl: this.imageUrl
      };
    },
    chooseThumbnailDialog() {
      return {
        isShow: this.isShowThumbnailModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Thumbnail แพ็กเกจ",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.thumbnailFile,
        thumbnailUrl: this.thumbnailUrl
      };
    },
    packageOptions: {
      get() {
        return this.value;
      },
      set(packageOptions) {
        return this.$emit("input", { ...this.value, packageOptions });
      }
    },
    expireDuration() {
      return this.value.expireDuration;
    },
    selectImageAlbumDialog() {
      return {
        isShow: this.isShowSelectImageAlbum,
        title: "Package Album",
        album: this.value.allImageToAlbum,
        canEdit: true,
        imageName: this.value.name,
        remark: {
          firstRemark: "สามารถเลื่อนตำแหน่งการแสดงผลได้",
          secondRemark: "รูปแรกจะเป็นรูปหลักของ package เสมอ"
        },
        dimension: {
          width: 300,
          height: 200,
          recommendWidth: 1200,
          recommendHeight: 800
        },
        titleForChooseImage: "เลือกรูป แพ็กเกจ"
      };
    },
    disabledAndCheckLanguageNotTH() {
      return this.disabled || this.isDisabledByLanguageNotTH
    },
    coinAmountPercent: {
      get() {
        return this.value.coinAmountPercent;
      },
      set(coinAmountPercent) {
        return this.$emit("input", { ...this.value, coinAmountPercent });
      }
    },
    coinAmountFix: {
      get() {
        return convertBathToStangAndRoundTwoDecimal(this.value.coinAmountFix);
      },
      set(coinAmountFix) {
        return this.$emit("input", { ...this.value, coinAmountFix: convertStangToBathAndRoundTwoDecimal(coinAmountFix) });
      }
    },
    coinAmountStatus: {
      get() {
        return this.value.coinAmountStatus;
      },
      set(coinAmountStatus) {
        return this.$emit("input", {
          ...this.value,
          coinAmountPercent: null,
          coinAmountFix: null,
          coinAmountStatus: coinAmountStatus
        });
      }
    },
    disabledCoinAmountPercent() {
      return this.disabledAndCheckLanguageNotTH || this.coinAmountStatus !== "percent"
    },
    disabledCoinAmountFix() {
      return this.disabledAndCheckLanguageNotTH || this.coinAmountStatus !== "fix"
    },
    homes() {
      const homes = this.value.homes

      return homes.map((home) => {
        const homeProjectSelected = home.project
          ? home.project
          : this.allProjects.find(
            (pro) => pro.project_code === home.project_code
          )

        const homeProject = homeProjectSelected
          ? homeProjectSelected
          : { project_name: "", project_code: "" }

        return {
          ...home,
          project: homeProject
        }
      })
    }
  },
  watch: {
    detail(newValue, oldValue) {
      if (this.value.language !== this.currentDetailLanguage) {
        try {
          const delta = JSON.parse(this.detail);
          this.editor.setContents(delta);
        } catch (err) {
          console.log('err:', err)
          this.editor.setText(this.detail);
        }
        this.detailLength = this.editor.getLength();
        setTimeout(() => this.editor.setSelection(this.detailLength, 0), 0)
        this.currentDetailLanguage = this.value.language;
      }
    },
    termsAndConditions(newValue, oldValue) {
      if (this.value.language !== this.currentTermLanguage) {
        try {
          const delta = JSON.parse(this.termsAndConditions);
          this.termEditor.setContents(delta);
        } catch (err) {
          console.log('err:', err)
          this.termEditor.setText(this.termsAndConditions);
        }
        this.termLength = this.termEditor.getLength();
        setTimeout(() => this.termEditor.setSelection(this.termLength, 0), 0)
        this.currentTermLanguage = this.value.language;
      }
    }
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      theme: "snow",
      formats: ["header", "bold", "underline", "link", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote", "link"]
        ],
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => false
            }
          }
        },
        clipboard: {
          matchVisual: false
        }
      },
      bounds: this.$refs.editor,
      placeholder: "เริ่มพิมพ์ที่นี่"
    });
    this.editor.on("text-change", () => {
      const detailText = this.editor.getContents();
      this.$emit("input", { ...this.value, ['detail']: JSON.stringify(detailText) });
      this.detailLength = this.editor.getLength();
    });

    this.termEditor = new Quill(this.$refs.term_editor, {
      theme: "snow",
      formats: ["header", "bold", "underline", "link", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote", "link"]
        ],
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => false
            }
          }
        },
        clipboard: {
          matchVisual: false
        }
      },
      bounds: this.$refs.term_editor,
      placeholder: "เริ่มพิมพ์ที่นี่"
    });
    this.termEditor.on("text-change", () => {
      const termText = this.termEditor.getContents();
      this.$emit("input", { ...this.value, ['termsAndConditions']: JSON.stringify(termText) });
      this.termLength = this.termEditor.getLength();
    });
  },
  methods: {
    handleChangeInput(key, value) {
      const isNumber = key === "price" || key === "billingCycle" || key === "coinAmountPercent"
      this.$emit("input", { ...this.value, [key]: isNumber ? +value : value });

      if (key === "services") {
        this.$emit("selectedService");
      }
    },
    handleClickChooseImageButton() {
      this.isShowSelectImageAlbum = true;
    },
    handleCancelSelectAlbumDialog() {
      this.isShowSelectImageAlbum = false;
    },
    handleConfirmSelectAlbumDialog(event) {
      const {
        allImageToAlbum,
        imageFile,
        packageAlbums
      } = event;

      this.$emit("input", {
        ...this.value,
        packageAlbums,
        allImageToAlbum,
        imageFile
      });

      this.isShowSelectImageAlbum = false;
    },
    handleClickChooseThumbnailButton() {
      this.isShowThumbnailModal = true;
    },
    handleClickSubPack(id) {
      // this.$router.push({ name: "PackageDetailPage", params: { id } });
      let routeData = this.$router.resolve({
        name: "PackageDetailPage",
        params: { id }
      });
      window.open(routeData.href, "_blank");
    },
    handleCancelChooseThumbnailDialog() {
      this.isShowThumbnailModal = false;
    },
    handleConfirmChooseThumbnailDialog(file) {
      this.$emit("input", { ...this.value, thumbnailFile: file });
      this.isShowThumbnailModal = false;
    },
    handleChangeTarget(targetId) {
      const target = this.targets.find((target) => target.id === targetId);

      this.$emit("input", { ...this.value, target });
    },
    handleChangeTotalPrice(price) {
      this.value.price = price;
    },
    async projectQuerySearch(queryString, cb) {
      const query = {
        text_search: queryString
      };
      const response = await baanRueJaiClient.admin.homes.search(query);
      const homes = response.data.result.homes;
      cb(homes);
    },
    handleSelectHome(item) {
      const homes = this.value.homes.concat(item);

      const uniqueHomes = Object.values(homes.reduce((acc, curr) => {
        acc[curr.home_id] = curr;
        return acc;
      }, {}));

      this.$emit("input", { ...this.value, homes: uniqueHomes });
    },
    handleClickDeleteHome(homeId) {
      this.value.homes.forEach((val, index) => {
        if (homeId === val.home_id) {
          this.value.homes.splice(index, 1);
        }
      });
    },
    allProject(projects) {
      this.allProjects = projects;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.editor {
  overflow-y: scroll;
  max-height: calc(100vh - 200px);
  min-height: 150px;
  margin-bottom: 20px;
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }

  &.sellerTradeParty {
    width: 350px;
  }

  &-amount {
    width: 100px;
  }
}

.select {
  margin-bottom: 20px;
}

.input>textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  >.image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}

.btn-action {
  margin-top: 30px;
}

.line-pricings {
  border: $border-head;
}

.user {
  padding: 6px 0;

  >.name {
    font-weight: bold;
  }

  >.name,
  >.home {
    line-height: 1.4;
  }

  >.home {
    color: #777;
    font-size: 12px;
    white-space: normal;
    word-break: break-word;
  }
}

.home-search-input {
  margin-bottom: 5px;
  width: 100%;
}

.user-list-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 8px 0;

  >.user {
    flex-grow: 1;
    padding: 0;
  }
}

.home-box {
  height: 500px;
  border: 1px solid rgb(192, 196, 204);
  overflow-y: scroll;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 5px;

  >.count {
    padding-top: 10px;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background-color: #fff;
  }
}
.checkbox-container .el-checkbox {
  display: block;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/components/PackageEditor.vue